/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Keen_Dark_Owl_CountInputs */

const en_keen_dark_owl_count = /** @type {(inputs: Keen_Dark_Owl_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rounds`)
};

const de_keen_dark_owl_count = /** @type {(inputs: Keen_Dark_Owl_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Runden`)
};

/**
* | output |
* | --- |
* | "{count} rounds" |
*
* @param {Keen_Dark_Owl_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_dark_owl_count = /** @type {((inputs: Keen_Dark_Owl_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Dark_Owl_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_dark_owl_count(inputs)
	return de_keen_dark_owl_count(inputs)
});